module.exports = __webpack_public_path__ + "img/southeast-winter-1920x550.90810238.jpg";